import groq from 'groq';

export const SLUG = groq`
  "slug": slug.current
`;

export const SHOP_SLUG = groq`
  "slug": "/shop/" + coalesce(slug.current, "")
`;
